import { Grid, GridAreas, StyledFlex, StyledMargin } from '@dreryk/react-components';

import { AFTER_ISSUED_FROM_WIDTH, DOSAGE_TO_QUANTITY_GAP } from '../../prescriptionGrid.constants';

import {
   StyledSentStandardPrescriptionGrid,
   StyledSentStandardPrescriptionRightColumn,
} from './SentStandardPrescriptionGrid.styled';

type SentStandardPrescriptionGridProps = {
   readonly dosage: JSX.Element;
   readonly issuedFrom: JSX.Element;
   readonly quantity: JSX.Element;
   readonly issuedTo: JSX.Element;
   readonly activeIngredients: JSX.Element;
   readonly additionalEntitlementTypes: JSX.Element;
   readonly additionalRequirementTypes: JSX.Element;
   readonly numericalDosage: JSX.Element;
   readonly treatmentDaysCount: JSX.Element | undefined;
   readonly medicineSufficientFor: JSX.Element | undefined;
   readonly prescriptionCategory: JSX.Element | undefined;
};

type AREA =
   | 'dosageRow'
   | 'dosage'
   | 'issuedFrom'
   | 'afterIssuedFrom'
   | 'additionalEntitlementTypes'
   | 'additionalRequirementTypes'
   | 'prescriptionCategory';

const useAreas = (prescriptionCategory?: boolean): GridAreas<AREA> => ({
   small: {
      template: [
         'dosageRow dosageRow dosageRow',
         'dosage dosage dosage',
         'issuedFrom afterIssuedFrom afterIssuedFrom',
         `additionalEntitlementTypes additionalRequirementTypes ${
            prescriptionCategory ? 'prescriptionCategory' : 'additionalRequirementTypes'
         }`,
      ],
      gridTemplateColumns: `minmax(0, 1fr) minmax(0, 1fr) ${AFTER_ISSUED_FROM_WIDTH}`,
      gap: '8px 4px',
   },
});

export const SentStandardPrescriptionGrid = (props: SentStandardPrescriptionGridProps): JSX.Element => {
   return (
      <StyledSentStandardPrescriptionGrid>
         <Grid<AREA>
            areas={useAreas(Boolean(props.prescriptionCategory))}
            testId={'sentStandardPrescription'}
            compact
            dosageRow={
               <StyledFlex
                  direction={'row'}
                  gap={DOSAGE_TO_QUANTITY_GAP}
                  alignItems={'flex-start'}
                  justifyContent={'space-between'}
                  flexWrap={'wrap'}
               >
                  {props.numericalDosage}
                  <StyledSentStandardPrescriptionRightColumn>
                     {props.quantity}
                     {props.treatmentDaysCount}
                  </StyledSentStandardPrescriptionRightColumn>
               </StyledFlex>
            }
            dosage={props.dosage}
            issuedFrom={props.issuedFrom}
            afterIssuedFrom={
               <StyledFlex direction={'row'} justifyContent={'flex-end'}>
                  <StyledFlex
                     direction={'column'}
                     gap={'2px'}
                     alignItems={'center'}
                     flex={`${AFTER_ISSUED_FROM_WIDTH} 0 0`}
                  >
                     <StyledMargin top={12}>
                        {props.issuedTo}
                        {props.medicineSufficientFor}
                        {props.activeIngredients}
                     </StyledMargin>
                  </StyledFlex>
               </StyledFlex>
            }
            additionalEntitlementTypes={props.additionalEntitlementTypes}
            additionalRequirementTypes={props.additionalRequirementTypes}
            prescriptionCategory={
               props.prescriptionCategory ? (
                  <StyledFlex direction={'row'} justifyContent={'flex-end'}>
                     <StyledSentStandardPrescriptionRightColumn>
                        {props.prescriptionCategory}
                     </StyledSentStandardPrescriptionRightColumn>
                  </StyledFlex>
               ) : undefined
            }
         />
      </StyledSentStandardPrescriptionGrid>
   );
};
